export default __webpack_public_path__ + "content/69b2f6f3cbe93e821d0c43be2f168195.svg";